export default __webpack_public_path__ + "static/media/game_5_r.09a98d84.png";